import styles from './InteractionBase.module.css'
import ContextBlock from '../../../components/Exercise/ContextBlock'
import { ReactNode } from 'react'
import { t } from 'i18next'

interface InteractionBaseProps {
  title: string
  subtitle?: string
  questionTitle?: string
  hideSubtitle?: boolean
  context?: string
  children: ReactNode
  isExercise?: boolean
  hasStepDisplay?: boolean
  isSocialMedia?: boolean
}

const InteractionBase = ({
  title,
  subtitle = t('interactionBase.subTitle'),
  questionTitle,
  context,
  isExercise,
  children,
  hasStepDisplay = false,
  isSocialMedia = false,
  hideSubtitle = false,
}: InteractionBaseProps) => {
  const headerClasses = []
  const hasContext = typeof context === 'string' && context?.trim() !== ''

  headerClasses.push(hasContext ? styles.exerciseHeader : styles.resultHeader)
  headerClasses.push(hasStepDisplay ? styles.headerMargin : '')

  const childrenClasses = [styles.childrenWrapper]

  if (isExercise) {
    childrenClasses.push(styles.exercise)
  }

  if (isSocialMedia) {
    childrenClasses.push(styles.socialMediaExercise)
  }

  return (
    <div className={styles.layout}>
      <div className={headerClasses.join(' ')}>
        <div className={styles.subheader}>
          <span className={styles.title}>{title}</span>
          {!hideSubtitle && (
            <div className={`${styles.title} ${styles.subtitle}`}>
              {subtitle}
            </div>
          )}
        </div>
        {questionTitle && (
          <div className={styles.question}>{questionTitle}</div>
        )}
      </div>
      <div className={childrenClasses.join(' ')}>{children}</div>
      {hasContext && (
        <ContextBlock
          text={context}
          title="Context"
          contextStyle="exerciseContext"
        />
      )}
    </div>
  )
}

export default InteractionBase
